import { propertyToUrl } from 'query-string-params';
import * as types from './types';
import { serverURI, firebaseConfig } from '../config';
import * as firebase from 'firebase';

const oss = require('ali-oss');
const co = require('co');
const request = require('superagent');

export const registerFirebase = () => {
    return async (dispatch) => {
        if (!firebase.apps.length) {
            console.log('Registering with firebase');
            try {
                let firebaseApp = firebase.initializeApp(firebaseConfig);
                if (firebaseApp) {
                    console.log('Successful: ' + firebaseApp.name);
                    if (firebase.auth().currentUser) {
                        console.log(firebase.auth().currentUser);
                    }

                    // firebase.auth().onAuthStateChanged((user) => {
                    //     if (user) {
                    //         console.log('User logged in.\n' + JSON.stringify(user));
                    //         request.post(serverURI + '/v1/admin/retrieve_staff')
                    //             .set('Content-Type', 'application/json')
                    //             .send({ uid: user.uid })
                    //             .then((resp) => {
                    //                 console.log(resp);
                    //                 if (resp.status === 200) {
                    //                     if (resp.body.state === 'ACTIVE') {
                    //                         dispatch({
                    //                             type: LOGIN,
                    //                             payload: resp.body
                    //                         });
                    //                     } else {
                    //                         dispatch({
                    //                             type: LOGOUT,
                    //                             payload: null
                    //                         });
                    //                     }
                    //                 } else {
                    //                     console.log('User not found in database');
                    //                 }
                    //             })
                    //             .catch((err) => {
                    //                 console.log('User not found in database');
                    //             });
                    //     } else {
                    //         console.log('User has logged out!');
                    //         dispatch({
                    //             type: LOGOUT,
                    //             payload: null
                    //         });
                    //     }
                    // });
                    dispatch({
                        type: types.FIREBASE_INIT,
                        payload: firebaseApp
                    });
                } else {
                    dispatch({
                        type: types.FIREBASE_INIT,
                        payload: null
                    });
                }
            } catch (err) {
                console.log(err);
                dispatch({
                    type: types.FIREBASE_INIT,
                    payload: null
                });
            }
        }
    }
}

export const setActivePage = (page) => {
    return {
        type: types.ACTIVE_PAGE,
        payload: page
    }
}

export const showMessage = (header, content, color) => {
    let message = {
        header: (header) ? header : '',
        content: (content) ? content : '',
        color: (color) ? color : 'green',
        hidden: false
    }

    return {
        type: types.SHOW_MESSAGE,
        payload: message
    }
}

export const hideMessage = () => {
    return {
        type: types.SHOW_MESSAGE,
        payload: {
            hidden: true
        }
    }
}

export const showLoading = (message) => {
    console.log('Loading message : ' + message);
    let loader = {
        message: (message) ? message : 'Loading',
        active: true
    }

    return {
        type: types.SHOW_LOADING,
        payload: loader
    }
}

export const hideLoading = () => {
    console.log('Hide Loading');
    return {
        type: types.SHOW_LOADING,
        payload: {
            message: '',
            active: false
        }
    }
}

// PRODUCTS
export const fetchProductCat = () => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/fetch_product_cat')
                .set('Content-Type', 'application/json')
                .send();

            let cats = resp.body;
            cats.forEach((cat) => {
                if (cat.sub.length > 0) cat.sub.unshift('All');
            });

            dispatch({
                type: types.FETCH_PRODUCT_CATEGORIES,
                payload: cats
            });
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.FETCH_PRODUCT_CATEGORIES,
                payload: []
            });
        }
    }
}

export const changeProductCat = (cat) => {
    return {
        type: types.CHANGE_PRODUCT_CATEGORY,
        payload: cat
    }
}

export const getProducts = () => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/get_products')
                .set('Content-Type', 'application/json')
                .send();

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_PRODUCTS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_PRODUCTS,
                payload: null
            });
        }
    }
}

export const getProductOptions = (product) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/get_product_options')
                .set('Content-Type', 'application/json')
                .send({ product: product });

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_PRODUCT_OPTIONS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_PRODUCT_OPTIONS,
                payload: null
            });
        }
    }
}

export const getProductMaterials = () => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/get_product_materials')
                .set('Content-Type', 'application/json')
                .send();

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_PRODUCT_MATERIALS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_PRODUCT_MATERIALS,
                payload: null
            });
        }
    }
}

export const getProductCosts = (query) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/get_product_costs')
                .set('Content-Type', 'application/json')
                .send(query);

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_PRODUCT_COSTS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_PRODUCT_COSTS,
                payload: []
            });
        }
    }
}

export const getMaterialList = (query) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/get_material_list')
                .set('Content-Type', 'application/json')
                .send({ type: query });

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_MATERIAL_LIST,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_MATERIAL_LIST,
                payload: null
            });
        }
    }
}

export const updateProductMaterials = (query) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/update_product_materials')
                .set('Content-Type', 'application/json')
                .send(query);

            if (resp.status === 200) {
                dispatch({
                    type: types.UPDATE_PRODUCT_MATERIALS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.UPDATE_PRODUCT_MATERIALS,
                payload: []
            });
        }
    }
}

// Pricing
export const addProductPricing = (pricing, offline) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/add_product_pricing')
                .set('Content-Type', 'application/json')
                .send({ pricing: pricing, offline: offline });

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_PRODUCT_PRICING,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.ADD_PRODUCT_PRICING,
                payload: null
            });
        }
    }
}

export const getProductPricing = (product, offline) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/get_product_pricing')
                .set('Content-Type', 'application/json')
                .send({ product: product, offline: offline });

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_PRODUCT_PRICING,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_PRODUCT_PRICING,
                payload: []
            });
        }
    }
}

export const getBookletPricing = (product, offline) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/get_booklet_pricing')
                .set('Content-Type', 'application/json')
                .send({ product: product, offline: offline });

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_BOOKLET_PRICING,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_BOOKLET_PRICING,
                payload: []
            });
        }
    }
}

export const updatePricingTable = (pricing, offline) => {
    console.log('Calling updatePricingTable');
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/update_pricing_table')
                .set('Content-Type', 'application/json')
                .send({ pricing: pricing, offline: offline });

            console.log(resp);
            if (resp.status === 200) {
                dispatch({
                    type: types.UPDATE_PRODUCT_PRICING,
                    payload: resp.body
                });
            } else {
                dispatch({
                    type: types.UPDATE_PRODUCT_PRICING,
                    payload: null
                });
            }
        } catch (err) {
            dispatch({
                type: types.UPDATE_PRODUCT_PRICING,
                payload: null
            });
        }
    }
}

export const updateBookletPricingTable = (pricing, offline) => {
    console.log('Calling updateBookletPricingTable');
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/update_booklet_pricing_table')
                .set('Content-Type', 'application/json')
                .send({ pricing: pricing, offline: offline });

            console.log(resp);
            if (resp.status === 200) {
                dispatch({
                    type: types.UPDATE_BOOKLET_PRICING,
                    payload: resp.body
                });
            } else {
                dispatch({
                    type: types.UPDATE_BOOKLET_PRICING,
                    payload: null
                });
            }
        } catch (err) {
            dispatch({
                type: types.UPDATE_BOOKLET_PRICING,
                payload: null
            });
        }
    }
}

export const getStickerPricing = (offline) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/get_sticker_pricing')
                .set('Content-Type', 'application/json')
                .send({ offline: offline });

            if (resp.status === 200) {
                console.log(resp.body);
                dispatch({
                    type: types.GET_STICKER_PRICING,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_STICKER_PRICING,
                payload: []
            });
        }
    }
}

export const updateStickerPricingTable = (pricing, offline) => {
    console.log('Calling updateStickerPricingTable');
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/update_sticker_pricing_table')
                .set('Content-Type', 'application/json')
                .send({ pricing: pricing, offline: offline });

            console.log(resp);
            if (resp.status === 200) {
                dispatch({
                    type: types.UPDATE_STICKER_PRICING,
                    payload: resp.body
                });
            } else {
                dispatch({
                    type: types.UPDATE_STICKER_PRICING,
                    payload: null
                });
            }
        } catch (err) {
            dispatch({
                type: types.UPDATE_STICKER_PRICING,
                payload: null
            });
        }
    }
}

// ORDERS
export const setOrderFilter = (filter) => {
    return {
        type: types.SET_ORDER_FILTER,
        payload: filter
    }
}

export const getOrders = (query) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/get_orders')
                .set('Content-Type', 'application/json')
                .send(query);
            dispatch({
                type: types.GET_ORDERS,
                payload: resp.body
            });
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.GET_ORDERS,
                payload: []
            });
        }
    }
}

export const processOrder = (data) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/process_order')
                .set('Content-Type', 'application/json')
                .send(data);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.UPDATE_ORDER,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const cancelOrder = (data) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/cancel_order')
                .set('Content-Type', 'application/json')
                .send(data);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.UPDATE_ORDER,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const addNote = (data) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/add_order_note')
                .set('Content-Type', 'application/json')
                .send(data);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.UPDATE_ORDER,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(JSON.stringify(err));
        }
    }
}

export const uploadBankSlip = (data) => {
    return async (dispatch) => {
        dispatch({
            type: types.BANKSLIP_UPLOAD
        });

        try {
            let resp = await request.post(serverURI + '/v1/admin/request_access')
                .set('Content-Type', 'application/json')
                .send();
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                let credentials = resp.body.credentials;
                let ossclient = new oss({
                    region: 'oss-ap-southeast-1',
                    accessKeyId: credentials.AccessKeyId,
                    accessKeySecret: credentials.AccessKeySecret,
                    stsToken: credentials.SecurityToken,
                    bucket: 'acewin'
                });

                co(function* () {
                    let filename = 'order_' + data.order_id + '_payment.' + data.file.name.split('.').pop();
                    let result = yield ossclient.put('bankslips/' + filename, data.file);

                    if (result) {
                        console.log(result);

                        let resp = yield request.post(serverURI + '/v1/admin/process_order')
                            .set('Content-Type', 'application/json')
                            .send({
                                orderID: data.order_id,
                                processInput: {
                                    paymentMethod: 'Bank In',
                                    paymentProvider: 'StaffUpload',
                                    paymentReference: filename,
                                    verifier: data.verifier
                                }
                            });

                        if (resp.status === 200) {
                            console.log('Resp 200 received!');
                            dispatch({
                                type: types.UPDATE_ORDER,
                                payload: resp.body
                            });
                        }

                        dispatch({
                            type: types.BANKSLIP_UPLOAD_COMPLETE,
                            payload: resp.status
                        });
                    } else {
                        console.log(data.file.name + ' upload failed!');
                        dispatch({
                            type: types.BANKSLIP_UPLOAD_COMPLETE,
                            payload: 500
                        });
                    }
                }).catch(function (err) {
                    console.log(err);
                    dispatch({
                        type: types.BANKSLIP_UPLOAD_COMPLETE,
                        payload: 500
                    });
                });
            }
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.BANKSLIP_UPLOAD_COMPLETE,
                payload: 500
            });
        }
    }
}

export const exportOrders = (state) => {
    return {
        type: types.EXPORT_ORDERS_REPORT,
        payload: state
    }
}

export const getOrdersReport = (params) => {
    return async (dispatch) => {
        console.log('Getting orders report');
        try {
            let url = serverURI + '/v1/admin/get_orders_report?' + propertyToUrl(params);

            window.open(url);
            dispatch({
                type: types.SHOW_LOADING,
                payload: {
                    message: '',
                    active: false
                }
            });
        } catch (err) {
            console.log('Error in get orders report request');
            console.log(err);
            dispatch({
                type: types.SHOW_LOADING,
                payload: {
                    message: '',
                    active: false
                }
            });
        }
    }
}

export const getCustomersReport = () => {
    return async (dispatch) => {
        console.log('Getting customers report');
        try {
            let url = serverURI + '/v1/admin/get_customers_report';

            window.open(url);
            dispatch({
                type: types.SHOW_LOADING,
                payload: {
                    message: '',
                    active: false
                }
            });
        } catch (err) {
            console.log('Error in get customers report request');
            console.log(err);
            dispatch({
                type: types.SHOW_LOADING,
                payload: {
                    message: '',
                    active: false
                }
            });
        }
    }
}

export const openCustomModal = (state) => {
    return {
        type: types.OPEN_CUSTOM_MODAL,
        payload: state
    }
}

// STAFFS
export const loginStaff = (user) => {
    return async (dispatch) => {
        console.log('User logged in.\n' + JSON.stringify(user));
        request.post(serverURI + '/v1/admin/login_staff')
            .set('Content-Type', 'application/json')
            .send({ uid: user.uid })
            .then((resp) => {
                console.log(resp);
                if (resp.status === 200) {
                    dispatch({
                        type: types.LOGIN,
                        payload: resp.body.value
                    });
                } else {
                    console.log('User not found in database');
                }
                dispatch({
                    type: types.SHOW_LOADING,
                    payload: {
                        message: '',
                        active: false
                    }
                });
            })
            .catch((err) => {
                console.log('User not found in database');
                dispatch({
                    type: types.SHOW_LOADING,
                    payload: {
                        message: '',
                        active: false
                    }
                });
            });
    }
}

export const logoutStaff = () => {
    return {
        type: types.LOGOUT,
        payload: null
    }
}

export const registerStaff = (staff, password) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/register_staff')
                .set('Content-Type', 'application/json')
                .send({
                    staff: staff,
                    password: password
                });

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_STAFFS,
                    payload: resp.body
                });
            } else {
                console.log('Register staff failed!');
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const getStaffs = (query) => {
    console.log('getStaffs');
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/get_staffs')
                .set('Content-Type', 'application/json')
                .send(query);
            dispatch({
                type: types.GET_STAFFS,
                payload: resp.body
            });
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.GET_STAFFS,
                payload: []
            });
        }
    }
}

export const getStaffById = (id) => {
    return {
        type: types.GET_STAFF_BY_ID,
        payload: id
    }
}

export const sortStaffs = (sortColumn) => {
    return {
        type: types.SORT_STAFFS,
        payload: sortColumn
    }
}

export const updateStaff = (staff) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/update_staff')
                .set('Content-Type', 'application/json')
                .send(staff);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.GET_STAFFS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const deleteStaff = (id) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/delete_staff')
                .set('Content-Type', 'application/json')
                .send(id);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.GET_STAFFS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const openStaffModal = (state) => {
    return {
        type: types.OPEN_ADD_STAFF_MODAL,
        payload: state
    }
}

// CUSTOMERS
export const getCustomers = (query) => {
    console.log('getCustomers');
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/get_customers')
                .set('Content-Type', 'application/json')
                .send(query);
            dispatch({
                type: types.GET_CUSTOMERS,
                payload: resp.body
            });
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.GET_CUSTOMERS,
                payload: []
            });
        }
    }
}

export const getCustomerById = (id) => {
    return {
        type: types.GET_CUSTOMER_BY_ID,
        payload: id
    }
}

export const sortCustomers = (sortColumn) => {
    return {
        type: types.SORT_CUSTOMERS,
        payload: sortColumn
    }
}

export const updateCustomer = (customer) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/update_customer')
                .set('Content-Type', 'application/json')
                .send(customer);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.GET_CUSTOMERS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const deleteCustomer = (id) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/delete_customer')
                .set('Content-Type', 'application/json')
                .send(id);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.GET_CUSTOMERS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const openCustomerModal = (state) => {
    return {
        type: types.OPEN_ADD_CUSTOMER_MODAL,
        payload: state
    }
}

export const exportCustomers = (state) => {
    return {
        type: types.EXPORT_CUSTOMERS_REPORT,
        payload: state
    }
}

export const exportCreditReport = (state) => {
    return {
        type: types.EXPORT_CREDIT_REPORT,
        payload: state
    }
}


export const retrieveCreditRecords = (customer) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/retrieve_credit_records')
                .set('Content-Type', 'application/json')
                .send({ customer: customer });
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.RETRIEVE_CREDIT_RECORDS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const topupCredit = (customer, staff, amount) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/topup_credit')
                .set('Content-Type', 'application/json')
                .send({ customer: customer, staff: staff, amount: amount });
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.TOPUP_CREDIT,
                    payload: resp.body
                });
            } else {
                dispatch({
                    type: types.TOPUP_CREDIT,
                    payload: null
                });
            }
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.TOPUP_CREDIT,
                payload: null
            });
        }
    }
}

// TODO: .send(date)
export const getCreditReport = (date) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/get_credit_report')
                .set('Content-Type', 'application/json')
                .send({});
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.GET_CREDIT_REPORT,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const openVoucherModal = (state) => {
    return {
        type: types.OPEN_VOUCHER_MODAL,
        payload: state
    }
}

export const getVouchers = () => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/get_vouchers')
                .set('Content-Type', 'application/json')
                .send();

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_VOUCHERS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_VOUCHERS,
                payload: null
            });
        }
    }
}

export const createVoucher = (params) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/create_voucher')
                .set('Content-Type', 'application/json')
                .send({ voucher: params });
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.CREATE_VOUCHER,
                    payload: resp
                });
            } else {
                dispatch({
                    type: types.CREATE_VOUCHER,
                    payload: resp
                });
            }
        } catch (err) {
            dispatch({
                type: types.CREATE_VOUCHER,
                payload: err.response
            });
        }
    }
}

export const deleteVoucher = (voucher_id) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/delete_voucher')
                .set('Content-Type', 'application/json')
                .send({ voucher_id: voucher_id });
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.DELETE_VOUCHER,
                    payload: resp.body
                });
            } else {
                dispatch({
                    type: types.DELETE_VOUCHER,
                    payload: null
                });
            }
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.DELETE_VOUCHER,
                payload: null
            });
        }
    }
}

export const verifyVoucher = (customerID, voucherCode) => {
    console.log('Verify voucher');

    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/verify_voucher')
                .set('Content-Type', 'application/json')
                .send({ customer_id: customerID, voucher_id: voucherCode });
            if (resp.status === 200) {
                dispatch({
                    type: types.VERIFY_VOUCHER,
                    payload: resp.body
                });
            } else {
                dispatch({
                    type: types.VERIFY_VOUCHER,
                    payload: resp.body
                });
            }
        } catch (err) {
            dispatch({
                type: types.VERIFY_VOUCHER,
                payload: err.response
            });
        }
    }
}

export const clearVoucher = () => {
    return {
        type: types.CLEAR_VOUCHER
    }
}

// Login Records
export const getLoginRecords = (query) => {
    console.log('getLoginRecords');
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/get_login_records')
                .set('Content-Type', 'application/json')
                .send(query);
            dispatch({
                type: types.GET_LOGIN_RECORDS,
                payload: resp.body
            });
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.GET_LOGIN_RECORDS,
                payload: []
            });
        }
    }
}

export const getLoginRecordsById = (id) => {
    return {
        type: types.GET_LOGIN_RECORDS_BY_ID,
        payload: id
    }
}

export const sortLoginRecords = (sortColumn) => {
    return {
        type: types.SORT_LOGIN_RECORDS,
        payload: sortColumn
    }
}

export const getSalesReports = (startDate, endDate) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/get_sales_report')
                .set('Content-Type', 'application/json')
                .send({ start_date: startDate, end_date: endDate });

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_SALES_REPORT,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_SALES_REPORT,
                payload: null
            });
        }
    }
}

export const getSalesReportsById = (id) => {
    return {
        type: types.GET_SALES_REPORT_BY_ID,
        payload: id
    }
}


export const sortSalesReports = (sortColumn) => {
    return {
        type: types.SORT_SALES_REPORT,
        payload: sortColumn
    }
}

export const exportSales = (state) => {
    return {
        type: types.EXPORT_SALES_REPORT,
        payload: state
    }
}

export const openHolidayModal = (state) => {
    return {
        type: types.OPEN_HOLIDAY_MODAL,
        payload: state
    }
}

export const sortHoliday = (sortColumn) => {
    return {
        type: types.SORT_HOLIDAY,
        payload: sortColumn
    }
}

export const addHoliday = (_id, description) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/add_holiday')
                .set('Content-Type', 'application/json')
                .send(_id, description);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.ADD_HOLIDAY,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(JSON.stringify(err));
        }
    }
}
export const getHolidays = (holiday) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/get_holidays')
                .set('Content-Type', 'application/json')
                .send(holiday);
            dispatch({
                type: types.GET_HOLIDAYS,
                payload: resp.body
            });
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.GET_HOLIDAYS,
                payload: []
            });
        }
    }
}

export const removeHoliday = (_id) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/remove_holiday')
                .set('Content-Type', 'application/json')
                .send({ _id });
            console.log({ _id });
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.REMOVE_HOLIDAY,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

// Quotes
export const setQuotesFilter = (filter) => {
    return {
        type: types.SET_QUOTES_FILTER,
        payload: filter
    }
}

export const getQuotes = (query) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/get_quotes')
                .set('Content-Type', 'application/json')
                .send(query);
            dispatch({
                type: types.GET_QUOTES,
                payload: resp.body
            });
        } catch (err) {
            console.log(err);
            dispatch({
                type: types.GET_QUOTES,
                payload: []
            });
        }
    }
}

export const addNoteQuotation = (data) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/add_quote_note')
                .set('Content-Type', 'application/json')
                .send(data);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.UPDATE_QUOTE,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(JSON.stringify(err));
        }
    }
}

export const processQuote = (data) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/process_quote')
                .set('Content-Type', 'application/json')
                .send(data);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.UPDATE_QUOTE,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const cancelQuote = (data) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/cancel_quote')
                .set('Content-Type', 'application/json')
                .send(data);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.UPDATE_QUOTE,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const sortQuotation = (sortColumn) => {
    return {
        type: types.SORT_QUOTATION,
        payload: sortColumn
    }
}


export const getPaymentTerms = () => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/get_payment_terms')
                .set('Content-Type', 'application/json')
                .send();

            if (resp.status === 200) {
                dispatch({
                    type: types.GET_PAYMENT_TERMS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: types.GET_PAYMENT_TERMS,
                payload: null
            });
        }
    }
}

export const addPaymentTerms = (term) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/add_payment_terms')
                .set('Content-Type', 'application/json')
                .send(term);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.ADD_PAYMENT_TERMS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(JSON.stringify(err));
        }
    }
}

export const removePaymentTerms = (term) => {
    return async (dispatch) => {
        try {
            let resp = await request.post(serverURI + '/v1/admin/remove_payment_terms')
                .set('Content-Type', 'application/json')
                .send(term);
            if (resp.status === 200) {
                console.log('Resp 200 received!');
                dispatch({
                    type: types.REMOVE_PAYMENT_TERMS,
                    payload: resp.body
                });
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export const createCustomerAccount = (customer) => {
    return async (dispatch) => {
        console.log(customer)
        try {
            let resp = await request.post(serverURI + '/v1/admin/create_customer_account')
                .set('Content-Type', 'application/json')
                .send(customer);
            dispatch({
                type: types.GET_CUSTOMERS,
                payload: resp.body
            });
        } catch (err) {
            console.log(err);
        }
    }
}

